import { configureStore } from "@reduxjs/toolkit";
import profileSlices from "./slices/profileSlices";
const store = configureStore({
  reducer: {
    profile: profileSlices,
  },
});

export default store;
